<template>
    <section class="my-5 wrapper" style="min-height: 70vh;">
      <div id="section-title-container">
        <div id="section-title" class="section-title my-5">
          <h3>参加企業一覧</h3>
        </div>
        <!-- company list -->
        <div class="company-list row">
            <router-link to="/company/{{company.public_id}}"  class="item col-12 col-md-6 col-lg-4 pt-auto d-flex align-items-end"
                v-for="company in webinar_exhibitor"
                @click="view_company(company.public_id)"
                :key="company.public_id">
                <div class="company-card p-3 mx-auto mt-4 text-center">
                    <div class="image mb-2 d-fles item-align-center w-100">
                        <img :src="company.company_logo_image" v-if="company.company_logo_image" alt="企業ロゴ" 
                        style="max-width:200px;" class="w-100 my-auto">
                    </div>
                    <div class="description">
                        <br>
                        <span class="fw-bold fs-6">
                            {{company.company_name}}
                        </span>
                    </div>
                </div>

            </router-link>
            <!-- <router-link to="/company/BS_SAESQDAl"  class="item col-12 col-md-6 col-lg-4">
                <div class="company-card px-2">
                    <div class="image mb-2 d-fles item-align-center">
                        <img class="w-100 my-auto" src="@/assets/corporate_logo/spirallogic.png" alt="spirallogic">
                    </div>
                    <div class="description">
                        <span >
                            ID:000000000
                        </span>
                        <br>
                        <span class="fw-bold fs-4">
                            事業社名
                        </span>
                    </div>
                </div>
            </router-link> -->
            
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import _ from 'lodash';
  import {Api} from '@/utiles/ApiConnect';
  
  export default {
    data: function() {
      return {
        // Webinar事業一覧
        webinar_exhibitor: [],
      };
    },

    /***
     * ライフサイクル
     */
    mounted: function() {
      this.getExhibitor();
    },
  
    /***
     * メソッド
     */
    methods: {
      // Webinar事業者一覧の取得
      getExhibitor: function() {

      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Exhibitor.Search',
          // 引数の指定株式会社松井製作所
          {},
      )
          // 実行結果の取得
          .done(function(result) {
            let webinar_exhibitor =
                _.sortBy(
                    result.data, ['company_name_read']);
            this.webinar_exhibitor = webinar_exhibitor;
            console.log(this.webinar_exhibitor)
            // this.webinar_exhibitor = webinar_exhibitor.reverse();
            // let matsui = webinar_exhibitor.find(x => x.company_name === '株式会社松井製作所');
            // this.webinar_exhibitor = this.webinar_exhibitor.filter(x => x.company_name != "株式会社松井製作所");
            // this.webinar_exhibitor = this.shuffle(this.webinar_exhibitor);
            // this.webinar_exhibitor.push(matsui);
          }.bind(this));
      },  
      // 事業者詳細へ
      view_company: function(company_id) {
        this.$router.push('/company/' + company_id);
        },
      shuffle: function(array) {
        let currentIndex = array.length,  randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex != 0) {
          // Pick a remaining element.
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;
          // And swap it with the current element.
          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
        return array;
      },
    },
  };
  </script>
  <style>
  
    span{
        color:black;
        text-decoration: none;
    }
    .company-list{
      max-width: 1308px;
    }
  </style>